// TODO: Fix janky transition on popover open
// (This component was copied from Sidebar/PremiumBadge, which already had that bug)

import React, { useState, useRef, useLayoutEffect } from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import $image_url from 'js/utils/image_url';
import _PremiumBadgeIcon from "PremiumBadge-PremiumBadgeIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/PremiumBadge.tsx?styleId=PremiumBadgeIcon";
import _Container from "PremiumBadge-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/PremiumBadge.tsx?styleId=Container";
import _Triangle from "PremiumBadge-Triangle.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/PremiumBadge.tsx?styleId=Triangle";
import _PopoverIconLaurel from "PremiumBadge-PopoverIconLaurel.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/PremiumBadge.tsx?styleId=PopoverIconLaurel";
import _PopoverInfo from "PremiumBadge-PopoverInfo.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/PremiumBadge.tsx?styleId=PopoverInfo";
import _PopoverText from "PremiumBadge-PopoverText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/PremiumBadge.tsx?styleId=PopoverText";
import _PopoverCTA from "PremiumBadge-PopoverCTA.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/PremiumBadge.tsx?styleId=PopoverCTA";


const PremiumBadgeIcon = /*#__PURE__*/styled("div", null, {
  displayName: "PremiumBadgeIcon",
  styles: _PremiumBadgeIcon
});

// The container, on load, has its leftmost edge aligned with the leftmost edge of the icon.
// In order for it to be centered about the center the icon, it must be translated:
// * left (-50%), so its center is aligned with the leftmost edge of the icon;
// * right (+9px), which is half the width of the icon (18px)
const CENTER_CONTAINER_TO_ICON = `-50% + 9px`;

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const Triangle = /*#__PURE__*/styled("div", null, {
  displayName: "Triangle",
  styles: _Triangle
});

const PopoverIconLaurel = /*#__PURE__*/styled("img", null, {
  displayName: "PopoverIconLaurel",
  styles: _PopoverIconLaurel
});

const PopoverInfo = /*#__PURE__*/styled("div", null, {
  displayName: "PopoverInfo",
  styles: _PopoverInfo
});

const PopoverText = /*#__PURE__*/styled("div", null, {
  displayName: "PopoverText",
  styles: _PopoverText
});

const PopoverCTA = /*#__PURE__*/styled("button", null, {
  displayName: "PopoverCTA",
  styles: _PopoverCTA
});

const PremiumBadge = () => {
  const [showPopover, setShowPopover] = useState(false);

  return (
    <PremiumBadgeIcon
      onMouseOver={() => setShowPopover(true)}
      onMouseLeave={() => setShowPopover(false)}
    >
      <img src={$image_url('premium/Badge-Laurel.svg')} />
      {showPopover && <PremiumBadgePopover />}
    </PremiumBadgeIcon>
  );
};

const PremiumBadgePopover = () => {
  const parentContainer = useRef(null);
  const triangle = useRef(null);
  useLayoutEffect(() => {
    // type never?
    const containerDOM = parentContainer?.current;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
    const containerDOMRect = containerDOM?.getBoundingClientRect();
    const containerRightEdge = containerDOMRect.right;
    const viewportWidth = window.innerWidth;
    const MINIMUM_RIGHT_PADDING = 10;
    if (containerRightEdge > viewportWidth - MINIMUM_RIGHT_PADDING) {
      //  adjustedEdge
      //       |
      //      viewport    rightEdge
      //       | |           |
      //       x x           x
      //
      // distance btwn rightEdge and adjustedEdge is minPadding + (rightEdge - viewport)
      const distance =
        MINIMUM_RIGHT_PADDING + containerRightEdge - viewportWidth;
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      containerDOM.style.transform = `translateX(calc(${CENTER_CONTAINER_TO_ICON} - ${distance}px))`;

      // adjust the triangle
      const triangleDOM = triangle?.current;
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      triangleDOM.style.transform = `translateX(calc(-50% + ${distance}px))`;
    }
  });

  return (
    <Container
      ref={parentContainer}
      style={{ animation: '180ms fade-in ease-in' }}
    >
      <Triangle ref={triangle} />
      <PopoverIconLaurel src={$image_url('premium/Badge-Laurel.svg')} />
      <PopoverInfo>
        <PopoverText>
          270,000 Academics from 16,000 universities are Premium members.
        </PopoverText>
        <PopoverCTA
          as="a"
          href={routes.upgrade_url({
            feature: 'default',
            trigger: 'author-badge',
          })}
        >
          Learn more
        </PopoverCTA>
      </PopoverInfo>
    </Container>
  );
};

export default PremiumBadge;
